import ChairSearch from '../../src/legacy/ChairSearch';
export default ChairSearch;
